/* Numero pagina più alta finora raggiunta
0 | ... | N
*/
import { createContext } from "react";
const HighestPageContext = createContext({
    highestPage: 0,
    setHighestPage: (page) => {}
  });
export default HighestPageContext;